export var DEFAULT_SHEET_TIMEOUT = {
    enter: 200,
    exit: 150,
};
export var DEFAULT_SHEET_CLASSNAMES = {
    appear: "rmd-sheet--offscreen",
    appearActive: "rmd-sheet--enter rmd-sheet--visible",
    enter: "rmd-sheet--offscreen",
    enterActive: "rmd-sheet--enter rmd-sheet--visible",
    exit: "rmd-sheet--exit",
    exitActive: "rmd-sheet--offscreen",
    exitDone: "rmd-sheet--offscreen rmd-sheet--hidden",
};
//# sourceMappingURL=constants.js.map